import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { safeUpperCase, isMobileDevice } from '../../../common/utilities/utils';
import RedMarker from '../../../styles/staticAssets/images/RedMarker.svg';
import BlackMarker from '../../../styles/staticAssets/images/BlackMarker.svg';
import ModalComponent from '../../../molecules/Modal';
import { DINE_IN, DELIVERY, PICK_UP } from 'common/constants/SharedConstants';

export const LookupMapModal = props => {
  const { isOpen, handleClose, OrderReducerData } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const google = window.google;

  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  });

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };
  const modalProps = isMobile
    ? {
        id: 'OrderSaveModalPopup',
        role: 'dialog',
        modalTitleId: 'OrderSaveModalPopup',
        show: isOpen,
        classNames: 'LookUpmap-modal',
        showCloseBtn: true,
        closeButtonHandler: handleClose,
        autoFocus: true,
      }
    : {
        id: 'OrderSaveModalPopup',
        role: 'dialog',
        modalTitleId: 'OrderSaveModalPopup',
        show: isOpen,
        classNames: 'LookUpmap-modal',
        showCloseBtn: true,
        showBackBtn: false,
        closeButtonHandler: handleClose,
        // backButtonHandler: handleClose,
        autoFocus: true,
      };

  function initMap() {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer();
    const map = new google.maps.Map(document.getElementById('maps'), {
      zoom: 16,
      center: {
        lat: Number(OrderReducerData?.store?.location?.latitude),
        lng: Number(OrderReducerData?.store?.location?.longitude),
      },
    });
    directionsRenderer.setMap(map);
    calculateAndDisplayRoute(directionsService, directionsRenderer);
  }

  function calculateAndDisplayRoute(directionsService, directionsRenderer) {
    const LatLng = {
      lat: Number(OrderReducerData?.store?.location?.latitude),
      lng: Number(OrderReducerData?.store?.location?.longitude),
    };
    const map = new google.maps.Map(document.getElementById('maps'), {
      zoom: 16,
      center: LatLng,
    });
    directionsService.route(
      {
        origin: {
          lat: Number(OrderReducerData?.store?.location?.latitude),
          lng: Number(OrderReducerData?.store?.location?.longitude),
        },
        destination: {
          lat: Number(OrderReducerData?.store?.location?.latitude),
          lng: Number(OrderReducerData?.store?.location?.longitude),
        },
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === 'OK') {
          directionsRenderer.setDirections(response);
          var loc = response.routes[0].legs[0];
          new google.maps.Marker({
            position: loc.end_location,
            map: map,
            visible: true,
            icon: BlackMarker,
            title: 'Delivery-Location',
          });
        } else {
          new google.maps.Map(document.getElementById('maps'), {
            zoom: 6,
            center: { lat: 20.5937, lng: 78.9629 },
          });
        }
      },
    );
  }

  function initStoreLocMap() {
    const myLatLng = {
      lat: Number(OrderReducerData?.store?.location?.latitude),
      lng: Number(OrderReducerData?.store?.location?.longitude),
    };
    const map = new google.maps.Map(document.getElementById('maps'), {
      zoom: 16,
      center: myLatLng,
    });
    new google.maps.Marker({
      position: myLatLng,
      map,
      visible: true,
      icon: RedMarker,
      title: 'KFC Store',
    });
  }
  useEffect(() => {
    if (
      OrderReducerData?.deliveryAddress !== null &&
      OrderReducerData?.store !== null &&
      safeUpperCase(OrderReducerData?.service) === safeUpperCase(DELIVERY)
    ) {
      initMap();
    } else if (
      (safeUpperCase(OrderReducerData?.service) === safeUpperCase(PICK_UP) ||
        safeUpperCase(OrderReducerData?.service) === safeUpperCase(DINE_IN)) &&
      OrderReducerData?.store !== null
    ) {
      initStoreLocMap();
    }
  });

  return (
    <div>
      {isOpen && (
        <ModalComponent {...modalProps}>
          <div>
            <div id='maps'></div>
          </div>
        </ModalComponent>
      )}
    </div>
  );
};

LookupMapModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
};

LookupMapModal.defaultProps = {
  isOpen: false,
  closeModal: null,
};

export default LookupMapModal;
